import * as types from './constants';

const initialState = {
  data: {},
  addLoading: false,
  errors_api: {}
};

const actions = {
  // Create Promotion
  [types.CREATE_PROMOTION_REQUEST]: state => {
    const data = {
      ...state,
      addLoading: true
    };

    return { ...data };
  },

  [types.CREATE_PROMOTION_DONE]: (state, { payload }) => {
    const data = {
      ...state,
      addLoading: false,
      data: payload,
      errors_api: {}
    };

    return { ...data };
  },

  [types.CREATE_PROMOTION_FAILED]: (state, { payload }) => {
    const data = {
      ...state,
      addLoading: false,
      errors_api: payload
    };

    return { ...data };
  },

  [types.CREATE_PROMOTION_RESET]: () => {
    const data = {
      ...initialState
    };

    return { ...data };
  }
};

export default (state = initialState, action) => {
  if (actions[action.type]) return actions[action.type](state, action);
  return state;
};

